var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cart-widget-toggle-base',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var count = ref.count;
var toggle = ref.toggle;
return [_c('button',{staticClass:"cart-widget-toggle btn btn-primary",on:{"click":toggle}},[_c('span',{staticClass:"button-caption"},[_c('i',{staticClass:"fa fa-shopping-cart"})]),_vm._v(" "),_c('span',{staticClass:"button-value"},[_vm._v(_vm._s(count))])])]}}])},[_vm._v(" "),_c('cart-widget-toggle-base')],1)}
var staticRenderFns = []

export { render, staticRenderFns }